import { ETLCodes } from "./ETLCodes.ts";
type EnumStringValueMap = {
  [K in ETLCodes]: string;
};
const defaultTranslations: EnumStringValueMap = {
  AccessCollaborationSpace: "Accéder à l'espace de collaboration",
  Action: "Action",
  ActionRoles: "Rôles d'action",
  Add: "Ajouter",
  AddNewJobInterviewDate: "Ajouter une nouvelle date d'entretien de fonction",
  AddNewOperationalInterviewDate:
    "Ajouter une nouvelle date d'entretien de fonctionnement",
  Administration: "Administration",
  Affectation: "Affectation",
  Agent: "Agent",
  AgentDetails: "Détails de l'agent",
  AgentFunctions: "Fonctions de l'agent",
  AgentList: "Liste des agents",
  AgentSaved: "Agent enregistré",
  Agents: "Agents",
  Annexes: "Annexes",
  ArchivedDossiers: "Dossiers archivés",
  AssessementInterviewStartDate: "Date de début de l'entretien d'évaluation",
  At: "À",
  Author: "Auteur",
  By: "Par",
  Cadre: "Cadre",
  CadreStatus: "Statut du cadre",
  CadreSubStatus: "Sous-statut du cadre",
  Cancel: "Annuler",
  CancelReason: "Raison de l'annulation",
  CannotDisplayPDF: "Impossible d'afficher le PDF",
  Clear: "Effacer",
  ClickOnPictureToEdit: "Cliquez sur l'image pour modifier",
  Code: "Code",
  Confirm: "Confirmer",
  ConfirmDelete: "Confirmer la suppression",
  ConfirmDisable: "Confirmer la désactivation",
  ConfirmEnable: "Confirmer l'activation",
  Copy: "Copier",
  CreatedOn: "Créé le",
  CycleNumber: "Numéro de cycle",
  CycleStartDate: "Date de début de cycle",
  DataTranslations: "Traductions de données",
  Date: "Date",
  Delete: "Supprimer",
  Description: "Description",
  Details: "Détails",
  DirectionOrService: "Direction ou service",
  Disable: "Désactiver",
  DiscussedElement: "Élément discuté",
  Documents: "Documents",
  Dossier: "Dossier",
  DossierDetails: "Détails du dossier",
  DossierList: "Liste des dossiers",
  DossierSaved: "Dossier enregistré",
  Dossiers: "Dossiers",
  Download: "Télécharger",
  Edit: "Modifier",
  Email: "Email",
  Enable: "Activer",
  EndDate: "Date de fin",
  EndTime: "Heure de fin",
  EnsureMfa: "Assurer l'authentification multi-facteurs",
  EntityId: "ID de l'entité",
  EntityName: "Nom de l'entité",
  Error: "Erreur",
  ErrorMessage_Unauthorized: "Message d'erreur : non autorisé",
  ErrorMessage_Unauthorized_title: "Erreur : non autorisé",
  EvaluationAgent: "Agent d'évaluation",
  EvaluationInterview: "Entretien d'évaluation",
  Export: "Exporter",
  FieldName: "Nom du champ",
  FirstName: "Prénom",
  FixMenuTooltip: "Fixer le menu",
  FormDirtyCancelButton: "Bouton d'annulation des modifications",
  FormDirtyCancelMessage: "Message d'annulation des modifications",
  FormDirtyCancelTitle: "Titre d'annulation des modifications",
  FormDirtyLeaveButton: "Bouton pour quitter sans enregistrer",
  FormDirtyUnsavedMessage: "Message : modifications non enregistrées",
  FormQuestionList: "Liste des questions du formulaire",
  FormQuestionSaved: "Question du formulaire enregistrée",
  FormQuestions: "Questions du formulaire",
  Forms: "Formulaires",
  Function: "Fonction",
  FunctionHasTechAbilities: "Compétence techniques",
  FunctionIsPerformed: "Fonction exercée",
  Functions: "Fonctions",
  Gender: "Genre",
  GeneralLoading: "Chargement en cours",
  GeneralNoData: "Aucune donnée disponible",
  GenerateEmptyReport: "Générer un rapport vide",
  GenerateReport: "Générer un rapport",
  GetTemplate: "Obtenir le modèle",
  GoBack: "Retour",
  Grade: "Grade",
  GradeFunctionList: "Grades et fonctions",
  GradeFunctions: "Grades et fonctions",
  GradeStartDate: "Date de début de grade",
  GradeStatus: "Statut du grade",
  GradeSubStatus: "Sous-statut du grade",
  Home: "Accueil",
  Image: "Image",
  ImageIsNotInTheCorrectFormatErrorMessage:
    "Le format de l'image est incorrect",
  Import: "Importer",
  ImportSuccess: "Importation réussie",
  ImportTranslationFile: "Importer un fichier de traduction",
  IsActive: "Est actif",
  IsCanceled: "Est annulé",
  IsRegisteredDelivery: "Est une livraison enregistrée",
  IsRegisteredDeliveryReceipt: "Est une réception de livraison enregistrée",
  JobInterview: "Entretien de fonction",
  JobInterviewDate: "Date de l'entretien de fonction",
  JobInterviewDateHistory: "Historique des dates d'entretien de fonction",
  Language: "Langue",
  LastCycleMention: "Mention du dernier cycle",
  LastName: "Nom de famille",
  LinkCopiedSuccessfully: "Lien copié avec succès",
  LoadingRequest: "Chargement de la requête",
  Login: "Connexion",
  Logout: "Déconnexion",
  MP: "Membre du personnel",
  Mention: "Mention",
  MentionDetails: "Détails de la mention",
  MentionList: "Liste des mentions",
  MentionSaved: "Mention enregistrée",
  Mentions: "Mentions",
  Menu: "Menu",
  ModifiedOn: "Modifié le",
  NPlus1: "N+1",
  NPlus2: "N+2",
  Name: "Nom",
  NationalRegisterNumber: "Numéro de registre national",
  NewAgent: "Nouvel agent",
  NewDossier: "Nouveau dossier",
  NewFormQuestion: "Nouvelle question de formulaire",
  NewJobInterviewDate: "Nouvelle date d'entretien de fonction",
  NewMention: "Nouvelle mention",
  NewUser: "Nouvel utilisateur",
  No: "Non",
  NoPDFToDisplay: "Aucun PDF à afficher",
  NotAuthorized: "Non autorisé",
  OperationalInterview: "Entretien de fonctionnement",
  OperationalInterviewDate: "Date d'entretien de fonctionnement",
  OperationalInterviewDateHistory:
    "Historique des dates d'entretien de fonctionnement",
  OptionalFunctionByZoneAnalysis:
    "Fonction(s) optionnelle(s) à la demande de l'agent et/ou selon nécessitées du service",
  PDFPreviewer: "Aperçu PDF",
  PleaseSelectCriteria: "Veuillez sélectionner les critères",
  PreviousValues: "Valeurs précédentes",
  Quantity: "Quantité",
  Question: "Question",
  QuickAccess: "Accès rapide",
  Refresh: "Actualiser",
  RegisteredDeliverySentDate: "Date envoie recommandé",
  RemarkOrObjective: "Remarque / Objectifs concernés",
  Remarks: "Remarques",
  Required: "Requis",
  RequiredFunctionByZoneAnalysis:
    "Fonctions obligatoires selon l'analyse de risque de la zone",
  RequiredOrOptional: "Requis ou optionnel",
  Role: "Rôle",
  Roles: "Rôles",
  SFE: "SFE",
  Save: "Enregistrer",
  SaveError: "Erreur d'enregistrement",
  Search: "Rechercher",
  SearchCriteriaPanel_Search: "Rechercher dans le panneau des critères",
  Select: "Sélectionner",
  SelectAll: "Tout sélectionner",
  SignatureMP: "Signature MP",
  SignatureSFE: "Signature SFE",
  StartDate: "Date de début",
  TableCriterias: "Critères de tableau",
  TableResults: "Résultats de tableau",
  ToolTip_DownloadPdf: "Télécharger le PDF",
  ToolTip_PreviewPdf: "Aperçu du PDF",
  TranslationCode: "Code de traduction",
  Translations: "Traductions",
  TranslationsImportSuccess: "Importation réussie des traductions",
  UnFixMenuTooltip: "Détacher le menu",
  UnSelectAll: "Tout désélectionner",
  UpdateJobInterviewDate: "Mettre à jour la date de l'entretien de fonction",
  UpdateOperationalInterviewDate:
    "Mettre à jour la date de l'entretien de fonctionnement",
  User: "Utilisateur",
  UserActions: "Actions utilisateur",
  UserList: "Liste des utilisateurs",
  UserNotAuthorizedMessage: "Message d'utilisateur non autorisé",
  UserSaved: "Utilisateur enregistré",
  Users: "Utilisateurs",
  Validate: "Valider",
  View: "Afficher",
  Yes: "Oui",
  FormQuestionOperationals: "Question du formulaire de fonctionnement",
  FormQuestionOperationalList:
    "Liste des questions du formulaire de fonctionnement",
  NewFormQuestionOperational:
    "Nouvelle question du formulaire de fonctionnement",
  FormQuestionOperationalSaved:
    "Question du formulaire de fonctionnement enregistrée",
  sfRemark: "Points du SF",
  mpRemark: "Point du MP",
  TaskList: "Liste des tâches",
  Task: "Tâche",
  IsClosed: "Est fermée",
  GoToDossier: "",
  FinishTask: "Cloturer la tâche",
  SendForSigning: "Envoyer pour signature",
  DocumentSignedAndSentToSigning: "Document signé et envoyé pour signature",
  GenerateReportForDiscussion: "Générer le rapport pour discussion",
  DownloadPdf: "Télécharger le PDF",
  ViewAgent: "Voir l'agent",
  ViewTask: "Voir la tâche",
  AgentGradeId: "Grade",
  AgentFirstname: "Firstname",
  AgentId: "Agent",
  AgentN1: "N+1",
  AgentN2: "N+2",
  AgentName: "Lastname",
  LastCycleMentionId: "Mention du dernier cycle",
  LastJobInterviewReminder: "Date dernier rappel Entretien de fonction",
  LastJobInterviewReportReminder: "Date dernier rappel Rapport de fonction",
  LastJobInterviewSigningReminder: "Date dernier rappel signature",
  Dashboard: "Dashboard",
  Status: "Statut",
  Sign: "Signer",
  RefuseSigning: "Refus de signer",
  FunctionalDirectorName: "Directeur fonctionnel",
  FunctionAndDirectorList: "Liste des directions",
  NewFunction: "Nouvelle fonction",
  FunctionSaved: "Fonction sauvée",
  Note: "Note",
  Configuration: "Configuration",
  FunctionalDirectorList: "Liste des directeurs",
  FunctionalDirectorSaved: "Directeur sauvé",
  FunctionalDirector: "Directeur fonctionnel",
  PleaseCompleteJobInterview:
    "Completer la date d'entretien de fonction dans le detail du dossier avant de pouvoir continuer",
  edossier_status_Error: "Erreur",
  edossier_status_EntretienFonctionDateEntretienADefinir:
    "Entretien de fonction à definir",
  edossier_status_noStatus: "Aucun status",
  N2Comment: "Commentaire du N+2",
  Comment: "Commentaire",
  CommentSaved: "Commentaire sauvé",
  NPlus2VisaDate: "N+2 Visa Date",
  SubstitutionList: "Changements de N+1 / N+2",
  SubstituteName: "Remplaçant",
  SubstitutionStartDate: "Date de début",
  SubstitutionEndDate: "Date de fin",
  Substitutions: "Changements de N+1 / N+2",
  NewSubstitution: "Nouveau changement",
  SubstitutionDetails: "Détails",
  SubstitutionSaved: "Changement enregistré",
  Substitute: "Remplaçant",
  SubstitutionAgentName: "Agent",
  Specialities: "Spécificités",
  CanBeEdited: "Peut être édité",
  ObjectiveQuestionList: "Liste des Objectifs",
  NewObjectiveQuestion: "Nouvel objectif",
  ObjectiveQuestionSaved: "Objectif enregistré",
  ResultObjectives: "Objectifs axés sur le résultat",
  WhoDoesWhat: "Qui fait quoi?",
  Delay: "Délais?",
  TimeLastModified: "Date de derniere modification",
  ImportError: "",
  ExportTemplate: "",
  UpdateExistingItems: "",
  ChooseAFile: "",
  Browse: "",
  DescriptionFile: "",
  AddFile: "Ajouter un fichier",
  DownloadError: "Une erreur est survenue lors du téléchargement du fichier",
  ToolTip_DownloadDoc: "Télécharger le document",
  ToolTip_DownloadFunctionDoc: "Télécharger la fiche de fonction",
  HasSkillCertificate: "Attestation de Gestion des compétences et évaluation",
  FormType: "Type de formulaire",
  EvaluationInterviewDate: "Date de l'entretien d'évaluation",
  Motivation: "Motivation",
  Strength: "Points forts",
  Weakness: "Points d'attention",
  Conclusion: "Conclusion générale",
  Competences: "Compétences",
  Level: "Niveau",
  Evaluation: "Evaluation",
  PleaseCompleteEvaluationInterview:
    "Compléter la date d'entretien d'évaluation dans le detail du dossier avant de pouvoir continuer",
  ReportCreated: "Rapport créé",
  ReportFailedToCreate: "Erreur lors de la création du rapport",
  File: "Fichier",
  PleaseCompleteOperationalInterview:
    "Completer la date d'entretien de fonctionnement dans le detail du dossier avant de pouvoir continuer",
  AskingAgent: "Agent demandeur",
  OtherSubjects: "Autres sujets",
  SpecificElementsForTheDay: "Eléments spécifiques mis à l'ordre du jour",
  PreviousOperationalInterview: "Entretiens de fonctionnement précédents",
  OperationalInterviewNumber: "Numéro d'entretien",
  Annexes_Fonction: "Annexe Fonction",
  Annexes_Formation: "Annexe Formation",
  CycleType: "Type de cycle",
  PutCycleOnHold: "Suspendre le cycle",
  CloseCycleWithoutMention: "Cloturer le cycle sans changer la mention",
  CloseCycleWAndChangeMention: "Cloturer le cycle et changer la mention",
  AreYouSureToHoldDossier: "Etes-vous sûr de vouloir suspendre le cycle ?",
  DossierSuccessfullyPutOnHold: "Cycle suspendu",
  AreYouSureToCloseDossierWithoutMention:
    "Etes-vous sûr de vouloir cloturer le cycle sans changer la mention ?",
  DossierSuccessfullyClosed: "Cycle cloturé",
  FunctionIsPerformedShort: "F.E.",
  FunctionHasTechAbilitiesShort: "C.T.",
  CycleManagement: "Gestion du cycle",
  OnlyUser: "Only self tasks",
  LastEvaluationInterviewReportReminder:
    "LastEvaluationInterviewReportReminder",
  LastEvaluationInterviewSigningReminder:
    "LastEvaluationInterviewSigningReminder",
  JobSfeSignatureDate: "Signature entretien de fonction",
  OperationalSfeSignatureDate: "Signature entretien de fonctionnement",
  EvaluationSfeSignatureDate: "Signature entretien d'évaluation",
  LastEvaluationInterviewReminder: "LastEvaluationInterviewReminder",
  PleaseSignJobInterview:
    "Veuillez signer l'entretien de fonction avant de créer un autre entretien.",
  IsGp: "Gardien du processus",
  LastOperationalInterviewReminder: "LastOperationalInterviewReminder",
  LastOperationalInterviewReportReminder:
    "LastOperationalInterviewReportReminder",
  DossierCancelled: "Cycle annulé",
  CancelCycle: "Annuler le cycle",
  CancellationReason: "Raison de l'annulation",
  edossier_status_EntretienFonctionEntretienConfirme:
    "Entretien de fonction date confirmée",
  edossier_status_EntretienFonctionSigneEnvoye:
    "Entretien de fonction signé et envoyé",
  edossier_status_EntretienFonctionnementEntretienConfirme:
    "Entretien de fonctionnement date confirmée",
  edossier_status_EntretienFonctionnementSigneEnvoye:
    "Entretien de fonctionnement signé et envoyé",
  edossier_status_EntretienEvaluationEntretienConfirme:
    "Entretien d'évaluation date confirmée",
  edossier_status_EntretienEvaluationSigneEnvoye:
    "Entretien d'évaluation signé et envoyé",
  edossier_status_OnHold: "En pause",
  edossier_status_Cancelled: "Annulé",
  edossier_status_Closed: "Fermé",
  CancellationReasons: "Raisons d'annulation",
  CancellationReasonList: "Liste des raisons d'annulation",
  CancellationReasonSaved: "Raison d'annulation sauvegardée",
  NewCancellationReason: "Nouvelle raison d'annulation",
  Text: "Texte",
  Position: "Poste",
  AtleastOneFunction: "Au moins une fonction requise",
  FirstSubjectRequired: "Le premier sujet est requis",
  NeedToBeChecked: "doit être coché",
  CT: "CT",
  FE: "FE",
};
export default defaultTranslations;
